import { useState } from 'react';
import { $userStore } from '@lib/store/userManagement';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import type { UserProfileResponse } from '@shared/api/rest/users';
import { UserSidebarItems } from './userSidebarItems';
import { ChangePasswordModal, DeleteUserModal, EditDetailsModal, LockUserModal } from '../modals';

export interface IUserSidebarProps {
  user: UserProfileResponse;
}

export const UserSidebar = (props: IUserSidebarProps) => {
  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);
  const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false);
  const [showLockModal, setShowLockModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  const { navigate } = useRouteHook();

  const lockUserHandler = () => $userStore.events.lockUser(props.user.id);
  const unlockUserHandler = () => $userStore.events.unlockUser(props.user.id);
  const deleteUserHandler = async () => {
    const statusCode = (await $userStore.events.deleteUser(props.user.id)) as unknown as number;
    if (statusCode === 204) navigate(RoutePaths.users.onNavigate({ successDeleted: true }));
  };

  return (
    <>
      <div className='w-80 p-6 bg-white dark:bg-soft-black'>
        <UserSidebarItems
          user={props.user}
          setShowDetailsModal={() => setShowDetailsModal(true)}
          setShowLockModal={() => setShowLockModal(true)}
          setShowPasswordModal={() => setShowPasswordModal(true)}
          setShowDeleteModal={() => setShowDeleteModal(true)}
        />
      </div>
      <EditDetailsModal show={showDetailsModal} onClose={() => setShowDetailsModal(false)} user={props.user} />
      <ChangePasswordModal show={showPasswordModal} onClose={() => setShowPasswordModal(false)} userId={props.user.id} />
      <LockUserModal
        show={showLockModal}
        onClose={() => setShowLockModal(false)}
        onSave={props.user.locked ? unlockUserHandler : lockUserHandler}
        locked={props.user.locked}
      />
      <DeleteUserModal open={showDeleteModal} close={() => setShowDeleteModal(false)} deleteUser={deleteUserHandler} />
    </>
  );
};
